var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _path2, _path3, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHotel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.01367,9.25h-12a.7502.7502,0,0,0-.75.75v3.25h-9.25a.7502.7502,0,0,0-.75.75v3.25H20.01416a.7502.7502,0,0,0-.75.75V61.92993a.18045.18045,0,0,0,0,.14014V70a.7502.7502,0,0,0,.75.75H60.01367a.7502.7502,0,0,0,.75-.75V18a.7502.7502,0,0,0-.75-.75h-3.25V14a.7502.7502,0,0,0-.75-.75h-9.25V10A.7502.7502,0,0,0,46.01367,9.25Zm-11.25,1.5h10.5v2.5h-10.5Zm-3.5,58.5H20.76416v-6.5H31.26367Zm4.14392-6.35791c-.02331.09668-.04406.19287-.0614.29175A4.56184,4.56184,0,0,0,35.26367,64v5.25h-2.5v-6.5H35.4375C35.42432,62.79688,35.41931,62.845,35.40759,62.89209ZM43.26367,69.25h-6.5V64a3.21747,3.21747,0,0,1,.05506-.54468c.01355-.0747.02746-.14917.0465-.22314.01734-.07056.04248-.1377.06421-.2063a3.41,3.41,0,0,1,.28833-.64893l.001-.001a3.31748,3.31748,0,0,1,.70483-.84375c.0608-.05152.11975-.105.18421-.15186.0636-.04736.12976-.09009.19641-.13232a3.23863,3.23863,0,0,1,.375-.20386c.03-.01367.0581-.03125.08838-.044a3.26114,3.26114,0,0,1,.52807-.1643c.0448-.01026.09009-.0188.1355-.0271a2.90834,2.90834,0,0,1,1.16529.00024c.04516.00806.09033.0166.135.02686a3.22538,3.22538,0,0,1,.529.16455c.02881.01221.05542.02881.08386.04175a3.20464,3.20464,0,0,1,.38171.20727c.0647.041.12891.08252.19068.12842.06958.05078.13354.10791.19873.16406a3.319,3.319,0,0,1,.69409.834l.001.001a3.43215,3.43215,0,0,1,.28393.63745c.02344.073.05005.14478.06836.22022.0188.07251.03223.14575.04566.21924A3.23563,3.23563,0,0,1,43.26367,64Zm4,0h-2.5V64a4.56184,4.56184,0,0,0-.08252-.81616c-.01733-.09888-.03808-.19531-.06152-.292-.01172-.04688-.0166-.095-.02979-.14185h2.67383Zm12,0h-10.5v-6.5h10.5Zm0-50.5v42.5H43.87207c-.0813-.11353-.17529-.21631-.266-.32227-.037-.04321-.07031-.08984-.10864-.13159-.103-.11181-.2118-.21533-.32495-.31714-.0802-.07226-.16443-.13891-.249-.20556a4.75188,4.75188,0,0,0-.49682-.342c-.12635-.07593-.25476-.147-.38758-.2107-.09985-.04736-.19824-.09472-.30163-.13525a4.72114,4.72114,0,0,0-.68494-.21314c-.06811-.01513-.13684-.02563-.20581-.03808a4.16,4.16,0,0,0-1.66577,0c-.06909.01245-.13806.023-.20618.03833a4.7,4.7,0,0,0-.68384.21265c-.10437.04077-.20373.08862-.30444.13647-.13.0625-.25574.13232-.37952.2063a4.74042,4.74042,0,0,0-.5133.354c-.07923.06275-.15821.125-.23352.19263-.11646.10449-.22827.21094-.334.32617-.02209.02417-.041.05127-.06274.07593a4.81789,4.81789,0,0,0-.30811.37329H20.76416V18.75H59.26367Zm-4-4v2.5h-30.5v-2.5h30.5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.25,
    y: 54,
    width: 1.5,
    height: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.25,
    y: 54,
    width: 1.5,
    height: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 47.25,
    y: 54,
    width: 1.5,
    height: 4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 55.25,
    y: 54,
    width: 1.5,
    height: 4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 23.25,
    y: 46,
    width: 1.5,
    height: 4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 31.25,
    y: 46,
    width: 1.5,
    height: 4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 39.25,
    y: 46,
    width: 1.5,
    height: 4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 47.25,
    y: 46,
    width: 1.5,
    height: 4
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 55.25,
    y: 46,
    width: 1.5,
    height: 4
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 23.25,
    y: 38,
    width: 1.5,
    height: 4
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 31.25,
    y: 38,
    width: 1.5,
    height: 4
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 39.25,
    y: 38,
    width: 1.5,
    height: 4
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 47.25,
    y: 38,
    width: 1.5,
    height: 4
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 55.25,
    y: 38,
    width: 1.5,
    height: 4
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 23.25,
    y: 30,
    width: 1.5,
    height: 4
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 31.25,
    y: 30,
    width: 1.5,
    height: 4
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 39.25,
    y: 30,
    width: 1.5,
    height: 4
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 47.25,
    y: 30,
    width: 1.5,
    height: 4
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 55.25,
    y: 30,
    width: 1.5,
    height: 4
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 23.25,
    y: 22,
    width: 1.5,
    height: 4
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 31.25,
    y: 22,
    width: 1.5,
    height: 4
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 39.25,
    y: 22,
    width: 1.5,
    height: 4
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 47.25,
    y: 22,
    width: 1.5,
    height: 4
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 55.25,
    y: 22,
    width: 1.5,
    height: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.75,70V66.63281a2.75,2.75,0,1,0-1.5,0V70Zm-2-6A1.25,1.25,0,1,1,66,65.25,1.25116,1.25116,0,0,1,64.75,64Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75,70V66.63281a2.75,2.75,0,1,0-1.5,0V70Zm-2-6A1.25,1.25,0,1,1,14,65.25,1.25116,1.25116,0,0,1,12.75,64Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 56,
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.00708,
    cy: 66,
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 66,
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHotel);
export default __webpack_public_path__ + "static/media/icon_hotel.d725e1f9cbf2ab9131e1117fca1bc735.svg";
export { ForwardRef as ReactComponent };